import type { CallbackProviderConfig } from "../../schema/provider-core.js";
import { createCallbackProvider } from "./create.js";
import { registerProviderPlugin } from "../plugins/registry.js";
import type { TelemetryEventHandler, TelemetryProviderDefinition } from "../types.js";

registerProviderPlugin("callback", (config, _runtime) =>
  createCallbackProvider((config as CallbackProviderConfig).id),
);

export function Callback(
  config: Omit<CallbackProviderConfig, "type"> & {
    handler?: TelemetryEventHandler;
  },
): TelemetryProviderDefinition {
  const { handler, ...providerConfig } = config;

  return {
    id: providerConfig.id,
    type: "callback",
    toProviderConfig: () => ({ type: "callback", ...providerConfig }),
    inject(ctx) {
      if (handler) {
        ctx.registerCallback(providerConfig.id, handler);
      }
    },
  };
}
